import { IRootScopeService, ITimeoutService } from 'angular';
import $ from 'jquery';
import * as Ps from 'perfect-scrollbar';
import { IWixApi } from '../wix/wixApi';

export type IHeightCalc = ReturnType<typeof heightCalcFactory>;

/* @ngInject */
export function heightCalcFactory(
  wixApi: IWixApi,
  wixSdk,
  $timeout: ITimeoutService,
  $rootScope: IRootScopeService,
) {
  const height = {
    widget: null,
    rows: 200,
    initialRows: null,
    initialLocalRows: null,
  };
  let local = false;
  let fullsize = false;

  const border = {
    set: false,
    width: 0,
  };

  return {
    height,
    calcRowsHeight,
    calcWidgetHeight,
    scrollInit,
    getInitialRows,
    setBorder,
    setBorderWidth,
    setLocal,
    lengthenWidget,
    disableFullSize,
    resize,
    resizeNoShows,
    getHeightForNumber,
  };

  function calcRowsHeight() {
    const widgetHeight = $(document).height();
    const titleHeight = getHeight('title-bar');
    const menuHeight = getHeight('bit-menu-bar');
    height.rows = widgetHeight - titleHeight - menuHeight;
    if (border.set) {
      height.rows = height.rows - 2 * border.width;
    }
    //$('.widgetData').height(height.rows);
    if (!$rootScope.$$phase) {
      $rootScope.$apply();
    }
  }

  function calcWidgetHeight() {
    //height.widget = Math.max(document.documentElement.clientHeight,
    //    window.innerHeight || 0);
    height.widget = $(document).height();
  }

  function calcHeaderHeight() {
    const titleHeight = Number($('bit-title-bar').height());
    const menuHeight = Number($('bit-menu-bar').height());

    return titleHeight + menuHeight;
  }

  function getHeight(ob) {
    const el = document.getElementById(ob);
    if (el) {
      return el.offsetHeight;
    }
    return 0;
  }

  function getInitialRows() {
    if (local) {
      getInitialLocalRows();
    } else {
      getInitialUpcomingShows();
    }
  }

  function getInitialUpcomingShows() {
    if (!height.initialRows) {
      height.initialRows = $('#event-rows').height();
    }
  }

  function getInitialLocalRows() {
    if (!height.initialLocalRows) {
      height.initialLocalRows = $('#event-rows').height();
    }
  }

  function setLocal(setting) {
    local = setting;
  }

  function setBorder(bord) {
    border.set = bord;
    calcRowsHeight();
  }

  function setBorderWidth(width) {
    border.width = width;
    calcRowsHeight();
    scrollInit();
  }

  function scrollbar() {
    const holder = document.getElementById('widgetBody');
    let widgetHeight = height.widget;
    if (border.set) {
      widgetHeight = widgetHeight - 2 * border.width;
    }
    $('.widgetHolder').height(widgetHeight);
    // scrollbar manipulation moved to dev/main/app/desktop/desktop.html
  }

  function mobileAdjust() {
    $timeout(function() {
      const holder = document.getElementById('widgetBody');

      if (!holder) {
        return;
      }

      const mheight = holder.scrollHeight;
      wixSdk.setHeight(mheight);
      height.widget = mheight;
    });
  }

  function shortenWidget() {
    const holder = document.getElementById('widgetBody');
    //var bodyHeight = $('.widgetHolder').height();
    $('.widgetHolder').height(holder.scrollHeight);
    if (local) {
      height.rows = height.initialLocalRows;
    } else {
      height.rows = height.initialRows;
    }
  }

  function lengthenWidget() {
    let widgetHeight = $(document).height();
    if (border.set) {
      widgetHeight = widgetHeight - 2 * border.width;
    }
    $('.widgetHolder').height(widgetHeight);
    calcRowsHeight();
    fullsize = true;
  }

  function resizeUpcomingRows() {
    $timeout(function() {
      calcWidgetHeight();
      calcRowsHeight();
      $('#event-rows').height(height.rows);
      if (height.initialRows > height.rows) {
        scrollbar();
      } else {
        shortenWidget();
      }
    });
  }

  function resizeLocalRows() {
    $timeout(function() {
      calcWidgetHeight();
      calcRowsHeight();
      $('#event-rows').height(height.rows);
      if (height.initialLocalRows > height.rows) {
        scrollbar();
      } else {
        shortenWidget();
      }
    });
  }

  function disableFullSize() {
    fullsize = false;
  }

  function resize() {
    if (fullsize) {
      lengthenWidget();
    } else {
      scrollInit();
    }
  }

  function resizeNoShows() {
    lengthenWidget();
    const container = document.getElementById('no-shows');
    if (container) {
      try {
        Ps.update(container);
      } catch (e) {
        Ps.initialize(container);
      }
    }
  }

  function scrollInit() {
    if (wixApi.getMobileMode()) {
      mobileAdjust();
    } else if (fullsize) {
      calcRowsHeight();
      lengthenWidget();
    } else if (height.initialRows) {
      if (!$rootScope.$$phase) {
        $rootScope.$apply();
      }

      if (local) {
        resizeLocalRows();
      } else {
        resizeUpcomingRows();
      }
    }
  }

  function getHeightForNumber(numberOfTracks) {
    const noShows = $('bit-no-shows').length ? 300 : 0;
    const headerHeight = calcHeaderHeight();
    const visibleRowsHeight = Array.from($('bit-hr > div'))
      .slice(0, numberOfTracks)
      .map(element => $(element).height())
      .reduce((totalHeight, elementHeight) => totalHeight + elementHeight);

    return headerHeight + noShows + visibleRowsHeight;
  }
}
